import '@assets/styles/tiptap-editor.css';

import Modal from '@layouts/Modal';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import { firstError, hasError } from '@src/utils/errorMessageUtils';
import React from 'react';

export type ConvertUrlErrorResponse = {
  url?: string[];
};

interface EditorConvertUrlModalProps {
  isOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
  errors?: ConvertUrlErrorResponse;
}

export const EditorConvertUrlModal: React.FC<EditorConvertUrlModalProps> = ({
  isOpen,
  value,
  onChange,
  onSubmit,
  onClose,
  errors,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>YouTubeまたはVimeoのURLを貼り付ける</h2>
        </div>
        <button
          className='closeButton'
          onClick={onClose}
        >
          &times;
        </button>
        <div className='flex flex-col gap-2'>
          <input
            type='text'
            value={value}
            placeholder='https://example.com'
            onChange={(e) => onChange(e.target.value)}
            className={`w-full rounded border px-3 py-2 focus:outline-none ${
              hasError(errors?.url) ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-white'
            }`}
          />
          <ErrorMessage>{firstError(errors?.url)}</ErrorMessage>
        </div>
        <div className='modalFooter'>
          <button
            className='editorButton cancelButton'
            onClick={onClose}
          >
            キャンセル
          </button>
          <button
            className='editorButton insertButton'
            onClick={onSubmit}
          >
            動画を埋め込む
          </button>
        </div>
      </div>
    </Modal>
  );
};
